var render, staticRenderFns
import script from "./SharedCompanyForm.vue?vue&type=script&lang=js&"
export * from "./SharedCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578fdd68')) {
      api.createRecord('578fdd68', component.options)
    } else {
      api.reload('578fdd68', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/src/components/shared/SharedCompanyForm.vue"
export default component.exports